import { createFileRoute } from "@tanstack/react-router";
import { kennelSignInRoute, KennelSignInPage } from "@/features/provider-home";

export const Route = createFileRoute("/kennel/sign-in")({
    ssr: kennelSignInRoute.ssr,
    head: kennelSignInRoute.head,
    component: KennelSignInPage,
});
